// requestManager.js
import axios from "axios";

const sources = new Map();

export const getCancelSource = (key) => {
  if (sources.has(key)) {
    sources.get(key).cancel("Superseded by a newer request");
  }
  const source = axios.CancelToken.source();
  sources.set(key, source);
  return source;
};

export const clearCancelSource = (key, source) => {
  if (sources.get(key) === source) {
    sources.delete(key);
  }
};
